<div mat-dialog-title>
  <span>{{ "modals.object.add.title" | translate }}</span>
  <button mat-icon-button class="dialog-close" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <app-login-form #form submitText="forms.login.buttons.login" [withSubmit]="false" (onSubmit)="handleSubmit($event)"></app-login-form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button color="primary" [disabled]="dialogLoading" (click)="form.submit()">
    {{ "forms.general.buttons.save" | translate }}
  </button>
</mat-dialog-actions>
